import { createLoadableDictionaryReducer } from "~/app/store/loadableReducer";

const data = createLoadableDictionaryReducer<string>("externalContent");

export const externalContentReducer = data.reducer;
export const externalContentActions = data.actions;
